import { tickerItems } from "@/mocks/ticker";

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <section className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto flex w-full max-w-[1280px] items-center gap-3 px-4 py-3 md:px-6">
        <span className="hidden shrink-0 items-center gap-1.5 text-xs font-medium text-foreground-800 sm:flex">
          <span className="flex h-4 w-4 items-center justify-center text-primary-500">
            <i className="ri-flashlight-line text-sm" />
          </span>
          今日速览
        </span>
        <span className="hidden h-4 w-px shrink-0 bg-background-300 sm:block" />
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-8">
            {loop.map((item, index) => (
              <span key={`${item.time}-${index}`} className="flex items-center gap-2 whitespace-nowrap text-xs">
                <span className="text-foreground-400">{item.time}</span>
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900">
                  {item.tag}
                </span>
                <span className="text-foreground-700">{item.text}</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}